import styled, { css } from 'styled-components';

const COLORS = {
  primaryGrey: '#e0e0e0',
  secondaryGrey: '#a3a3a3',
  titleGrey: '#717171',
};

const defaultTheme = css`
  border: 2px solid ${COLORS.primaryGrey};
  padding: 15px;

  img {
    opacity: 0;
    padding: 0;
  }
`;

const highlightedTheme = css`
  border: 2px solid ${COLORS.secondaryGrey};
  padding: 15px;

  img {
    opacity: 1;
    padding: 0 15px;
  }
`;

const pickTheme = theme => {
  return {
    default: defaultTheme,
    highlighted: highlightedTheme,
  }[theme];
};

const Item = styled.div`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  align-items: center;
  border-radius: 16px;
  cursor: pointer;
  display: flex;
  font-size: 10px;
  font-family: 'Montserrat';
  margin-bottom: 25px;
  position: relative;
  transition: all 0.2s ease-in-out;

  &:hover {
    border: 2px solid #a3a3a3;
  }

  &:last-of-type {
    margin-bottom: 0;
  }

  ${({ highlighted }) => {
    const theme = !highlighted ? 'default' : 'highlighted';
    return pickTheme(theme);
  }}
`;

const Icon = styled.img`
  height: 12px;
  transition: all 0.2s ease-in-out;
  width: auto;
`;

const Title = styled.h2`
  font-size: 1.6em;
  color: ${COLORS.titleGrey};
  margin-bottom: 4px;
`;

const Address = styled.p`
  font-size: 1.4em;
  font-weight: 300;
  max-width: 90%;
`;

export { Item, Icon, Title, Address };
